import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { OverflowDetector } from 'react-overflow';
import classes from './TagInput.module.css';
import { formImages } from 'shared/utility';

class TagInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagsOverflowing: false,
    };
  }

  handleTagsOverflowDetection = (isOverflowed) => {
    this.setState({ tagsOverflowing: isOverflowed });
  };

  render = () => {
    const {
      tagCategory,
      selected,
      shortWindow,
      isGift,
      icon,
      iconImage: IconImage,
      iconclicked,
      clicked,
      offsetWidth,
      tags,
      placeHolder,
      prompt,
    } = this.props;
    const { tagsOverflowing } = this.state;
    const containerClasses = tagCategory === 'Logs' ? [classes.Container, classes.Logs] : [classes.Container, classes.NonLogs];
    if (selected === true) containerClasses.push(classes.Selected);
    if (shortWindow === true) containerClasses.push(classes.ShortWindow);
    if (isGift) containerClasses.push(classes.GiftPost);
    const ellipsesClasses = tagsOverflowing === true ? [classes.MoreEllipses, classes.Shown] : [classes.MoreEllipses];
    const fontIconClasses = icon === 'chevron-right' ? [classes.Icon, classes.ReducedSizeIcon] : [classes.Icon];
    let iconImage = IconImage ? formImages.find((formImage) => formImage.name === IconImage) : null;
    iconImage = iconImage ? <iconImage.image className={classes.ImageIcon} /> : null;
    const iconFont = icon ? <FontAwesomeIcon icon={icon} className={fontIconClasses.join(' ')} onClick={iconclicked} /> : null;

    return (
      <div name="tag-input-container" onClick={clicked} className={containerClasses.join(' ')}>
        <div style={{ maxHeight: `${53}px`, overflowY: 'visible' }} className={classes.TagsInput}>
          {prompt ? <span className={classes.TagsPrompt}>{prompt}</span> : null}

          {iconFont}
          <div
            ref={this.tagsContainer}
            id={`tags-container-${tagCategory}`}
            className={classes.Tags}
            style={{ width: offsetWidth !== null ? `calc(100% - ${offsetWidth})` : '100%' }}
          >
            <OverflowDetector className={classes.TagsOverflowDetector} onOverflowChange={this.handleTagsOverflowDetection}>
              {tags.length > 0 ? (
                tags.map((tagObject, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <span key={i} className={[classes.Tag, classes[tagObject.tagClassName]].join(' ')}>
                    {tagObject.tag}
                  </span>
                ))
              ) : (
                <span className={classes.placeholder}>{placeHolder}</span>
              )}
            </OverflowDetector>
            <div className={ellipsesClasses.join(' ')}>...</div>
          </div>
          <div className={classes.IconContainer}>{iconImage}</div>
        </div>
      </div>
    );
  };
}

export default TagInput;
